var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_28949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33338 14.6665H6.66671C4.15255 14.6665 2.89547 14.6665 2.11442 13.8854C1.33337 13.1044 1.33337 11.8473 1.33337 9.33317V7.99984C1.33337 5.48568 1.33337 4.2286 2.11442 3.44755C2.89547 2.6665 4.15255 2.6665 6.66671 2.6665H9.33338C11.8475 2.6665 13.1046 2.6665 13.8856 3.44755C14.6667 4.2286 14.6667 5.48568 14.6667 7.99984V9.33317C14.6667 11.8473 14.6667 13.1044 13.8856 13.8854C13.4502 14.3209 12.8668 14.5136 12 14.5988",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 2.6665V1.6665",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.6665V1.6665",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 6H11.0834H7.16671M1.33337 6H3.91671",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.3332C12 11.7014 11.7015 11.9998 11.3333 11.9998C10.9651 11.9998 10.6666 11.7014 10.6666 11.3332C10.6666 10.965 10.9651 10.6665 11.3333 10.6665C11.7015 10.6665 12 10.965 12 11.3332Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.66667C12 9.03487 11.7015 9.33333 11.3333 9.33333C10.9651 9.33333 10.6666 9.03487 10.6666 8.66667C10.6666 8.29847 10.9651 8 11.3333 8C11.7015 8 12 8.29847 12 8.66667Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 11.3332C8.66671 11.7014 8.36824 11.9998 8.00004 11.9998C7.63184 11.9998 7.33337 11.7014 7.33337 11.3332C7.33337 10.965 7.63184 10.6665 8.00004 10.6665C8.36824 10.6665 8.66671 10.965 8.66671 11.3332Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 8.66667C8.66671 9.03487 8.36824 9.33333 8.00004 9.33333C7.63184 9.33333 7.33337 9.03487 7.33337 8.66667C7.33337 8.29847 7.63184 8 8.00004 8C8.36824 8 8.66671 8.29847 8.66671 8.66667Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.3332C5.33333 11.7014 5.03485 11.9998 4.66667 11.9998C4.29848 11.9998 4 11.7014 4 11.3332C4 10.965 4.29848 10.6665 4.66667 10.6665C5.03485 10.6665 5.33333 10.965 5.33333 11.3332Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8.66667C5.33333 9.03487 5.03485 9.33333 4.66667 9.33333C4.29848 9.33333 4 9.03487 4 8.66667C4 8.29847 4.29848 8 4.66667 8C5.03485 8 5.33333 8.29847 5.33333 8.66667Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_28949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c631460c253e58521b5393e5e0946267.svg";
export { ForwardRef as ReactComponent };